export const getDynamicLinkDomain = () => {
  
    // let domainName =''
    // let hostName = window.location.hostname

    // if( hostName == 'localhost' || hostName == 'championsdev.championsacademy.ca' ){
    //     domainName = 'https://championsdev.championsacademy.ca'
        
        
    // }

    // else if( hostName == 'championstest.championsacademy.ca' ){
    //     domainName = 'https://championstest.championsacademy.ca'
    // }

    // else if(hostName == 'championsprod.championsacademy.ca' || hostName == 'championsacademy.ca'){
    //     domainName = 'https://championsacademy.ca'
    // }
    
    // else{
    //     domainName = 'https://championsdev.championsacademy.ca'
    // }
    
    
    // return domainName
    
    let domainName =''
    let hostName = window.location.hostname

    if( hostName == 'localhost' || hostName == 'webapp-dev.champstravel.ca' ){
        domainName = 'https://apidev.champstravel.ca'
        
    }

    else if( hostName == 'webapp-test.champstravel.ca' ){
        domainName = 'https://apitest.champstravel.ca'
    }

    else if(hostName == 'champstravel.ca'){
        domainName = 'https://api.champstravel.ca'
    }
    
    else{
        domainName = 'apidev.champstravel.ca'
    }
    
    
    return domainName
  
};
